import {
  FaProjectDiagram,
  FaDiscourse,
  FaHospitalAlt,
  FaHandsHelping,
  FaInfoCircle,
  FaQuestionCircle,
} from "react-icons/fa";
import React from "react";
const sublinks = [
  {
    page: "Information",
    links: [
      { label: "About WorldCom", icon: <FaInfoCircle />, url: "/Blog_1" },
      { label: "Refugees", icon: <FaHandsHelping />, url: "/Refugees" },
      { label: "How to use?", icon: <FaQuestionCircle />, url: "/How_To_Use" },
      {
        label: "Covid media",
        icon: <FaHospitalAlt />,
        url: "http://covidmediainfo.com/en",
      },
    ],
  },
  {
    page: "اطلاعات",
    links: [
      { label: "درباره WorldCom", icon: <FaInfoCircle />, url: "/Blog_1" },
      { label: "پناهندگان", icon: <FaHandsHelping />, url: "/Refugees" },
      {
        label: "چگونه استفاده کنیم؟",
        icon: <FaQuestionCircle />,
        url: "/How_To_Use",
      },
      {
        label: "Covid media",
        icon: <FaHospitalAlt />,
        url: "http://covidmediainfo.com/en",
      },
    ],
  },

  {
    page: "Courses",
    links: [
      { label: "Lessons for beginner", icon: <FaDiscourse />, url: "/Courses" },
      { label: "Projects", icon: <FaProjectDiagram />, url: "/Next_Course" },
    ],
  },
  {
    page: "دوره های آموزشی",
    links: [
      {
        label: "دوره های آموزشی برای مبتدیان",
        icon: <FaDiscourse />,
        url: "/Courses",
      },
      { label: "پروژه ها", icon: <FaProjectDiagram />, url: "/Next_Course" },
    ],
  },
];

export default sublinks;
